<template>
    <div
        v-if="loading"
        class="adapters_loader__container"
        :class="'adapters_loader__type_' + type"
    >
        <div v-if="pinToViewport" class="adapters_loader__viewport_pin">
            <div class="adapters_loader__loader"></div>
        </div>
        <div v-else class="adapters_loader__loader"></div>
    </div>
</template>

<script>
/**
 * Адаптер для компонента загрузки данных, прелоадера
 */
export default {
    name: "AdaptersLoader",
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: 'absolute',
            enum: ['absolute', 'static'],
        },
        background: {
            type: String,
            required: false,
            default: 'rgba(255, 255, 255, 0.3)',
        },
        /**
         * Держать спиннер в видимой области viewport
         * (для высоких контейнеров, где top:50% уезжает за экран)
         */
        pinToViewport: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.adapters_loader__container {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
}
.adapters_loader__type_absolute {
    position: absolute;
    background: v-bind(background);
}
.adapters_loader__type_static {
    position: relative;
    padding: 20px;
    min-width: 150px;
    min-height: 150px;
}
.adapters_loader__viewport_pin {
    position: sticky;
    top: 0;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.adapters_loader__viewport_pin .adapters_loader__loader {
    position: relative;
    left: auto;
    top: auto;
    margin: 0;
}
.adapters_loader__loader,
.adapters_loader__loader:before,
.adapters_loader__loader:after {
    border-radius: 50%;
    border: 3px solid transparent;
}
.adapters_loader__loader {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 66px;
    height: 66px;
    margin: -33px 0 0 -33px;
    border-top-color: #288306;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}
.adapters_loader__type_absolute .adapters_loader__loader {
  position: relative;
}
.adapters_loader__type_static .adapters_loader__loader {
  position: absolute;
}
.adapters_loader__loader:before {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border-top-color: #5ABF34;
    -webkit-animation: spin 3s linear infinite;
    animation: spin 3s linear infinite;
}
.adapters_loader__loader:after {
    content: "";
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-top-color: #9DE582;
    -webkit-animation: spin 1.5s linear infinite;
    animation: spin 1.5s linear infinite;
}
</style>
